<template>
  <vue-good-table
    :columns="columns"
    :rows="list"
    :pagination-options="$globals.vgt.pagination"
    :sort-options="{ initialSortBy: {field: 'created', type: 'desc'} }"
    style-class="uk-table uk-table-middle uk-table-divider uk-table-hover uk-margin-remove datatable"
    @on-row-click="onRowClick"
  />
</template>

<script>
export default {
  name: 'ComponentTableEnquiry',

  props: {
    filter: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Date Created',
          field: 'created'
        },
        {
          label: 'Date Updated',
          field: 'updated'
        },
        {
          label: 'Status',
          field: 'status',
          html: true
        }
      ]
    }
  },

  computed: {
    list() {
      const source = this.$store.state.enquiries.collection
      let data = null
      const rows = []

      if (this.filter) {
        data = source.filter((enquiry) => enquiry.info.status === 'new' || enquiry.info.status === 'open')
      } else {
        data = source
      }

      data.forEach((enquiry) => {
        rows.push({
          id: enquiry.id,
          name: `${enquiry.content.name.first || '-'} ${enquiry.content.name.last || '-'}`,
          created: this.$moment(enquiry.info.created.timestamp.seconds, 'X').format('DD/MM/YYYY - HH:mm:ss'),
          updated: enquiry.info.updated && enquiry.info.updated.timestamp ? this.$moment(enquiry.info.updated.timestamp.seconds, 'X').format('DD/MM/YYYY - HH:mm:ss') : 'Never',
          status: this.formatStatus(enquiry.info.status)
        })
      })

      return rows
    }
  },

  methods: {
    formatStatus(data) {
      let label = '<div class="uk-label uk-label-danger">N/A</div>'
      const option = this.$helpers.status.enquiry.find((o) => o.id === data)
      label = `<div class="uk-label uk-label-${option.class}">${option.value}</div>`
      return label
    },

    onRowClick(params) {
      this.$router.push({ name: 'enquiry-single', params: { id: params.row.id } })
    }
  }
}
</script>
